import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import ConfigurationModel from "./models/ConfigurationModel";

export default class ConfigurationEffect {
    public static async getConfigurazione(): Promise<ConfigurationModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getConfigurazione;
        return EffectUtility.getToModel<ConfigurationModel>(ConfigurationModel, endpoint);
    }
}
